import { render, staticRenderFns } from "./team-opportunities.vue?vue&type=template&id=5a9496b0&scoped=true&"
import script from "./team-opportunities.vue?vue&type=script&lang=js&"
export * from "./team-opportunities.vue?vue&type=script&lang=js&"
import style0 from "./team-opportunities.vue?vue&type=style&index=0&id=5a9496b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9496b0",
  null
  
)

component.options.__file = "team-opportunities.vue"
export default component.exports